// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2qqHf","right":"Footer_right__3V5In","buttons":"Footer_buttons__1ZPN7"};